var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EnvelopeFill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.075 5.8325C0.226227 5.16986 0.597983 4.57822 1.12938 4.15446C1.66078 3.73071 2.32033 3.49995 3 3.5H21C21.6797 3.49995 22.3392 3.73071 22.8706 4.15446C23.402 4.57822 23.7738 5.16986 23.925 5.8325L12 13.121L0.075 5.8325ZM0 7.5455V18.2015L8.7045 12.8645L0 7.5455ZM10.1415 13.745L0.2865 19.7855C0.52999 20.2989 0.91429 20.7326 1.39467 21.0362C1.87505 21.3397 2.43176 21.5005 3 21.5H21C21.5681 21.5001 22.1246 21.3389 22.6048 21.0351C23.0849 20.7313 23.4688 20.2975 23.712 19.784L13.857 13.7435L12 14.879L10.1415 13.7435V13.745ZM15.2955 12.866L24 18.2015V7.5455L15.2955 12.8645V12.866Z",
    fill: "url(#paint0_linear_862_6549)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_862_6549",
    x1: 12,
    y1: 3.5,
    x2: 12,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654D1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.30d2742debcb3656fd231fc6beebfe00.svg";
export { ForwardRef as ReactComponent };